import { MESSAGE, SUBSCRIPTIONS, SUBSCRIPTIONSCOIN } from "./../constants/actionTypes";
import * as api from "./../api/index.js";

export const subscription_create = (formData) => async (dispatch) => {
  try {
    const data = await api.subscription_create(formData);
    dispatch({ type: MESSAGE, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: MESSAGE, payload: error });
    return error?.response?.data;
  }
};

export const subscription_update = (formData) => async (dispatch) => {
  try {
    const data = await api.subscription_update(formData);
    dispatch({ type: MESSAGE, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: MESSAGE, payload: error });
    return error?.response?.data;
  }
};
export const subscription_status_update = (formData) => async (dispatch) => {
  try {
    const data = await api.subscription_status_update(formData);
    dispatch({ type: MESSAGE, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: MESSAGE, payload: error });
    return error?.response?.data;
  }
};
export const subscription_delete = (formData) => async (dispatch) => {
  try {
    const data = await api.subscription_delete(formData);
    dispatch({ type: MESSAGE, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: MESSAGE, payload: error });
    return error?.response?.data;
  }
};
export const all_subscription_list = (formData) => async (dispatch) => {
  try {
    const data = await api.all_subscription_list(formData);
    dispatch({ type: SUBSCRIPTIONS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: MESSAGE, payload: error });
    return error?.response?.data;
  }
};

export const coin_create = (formData) => async (dispatch) => {
  try {
    const data = await api.coin_create(formData);
    dispatch({ type: MESSAGE, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: MESSAGE, payload: error });
    return error?.response?.data;
  }
};

export const coin_update = (formData) => async (dispatch) => {
  try {
    const data = await api.coin_update(formData);
    dispatch({ type: MESSAGE, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: MESSAGE, payload: error });
    return error?.response?.data;
  }
};

export const coin_status_update = (formData) => async (dispatch) => {
  try {
    const data = await api.coin_status_update(formData);
    dispatch({ type: MESSAGE, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: MESSAGE, payload: error });
    return error?.response?.data;
  }
};

export const coin_list_admin = (formData) => async (dispatch) => {
  try {
    const data = await api.coin_list_admin(formData);
    dispatch({ type: SUBSCRIPTIONSCOIN, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: MESSAGE, payload: error });
    return error?.response?.data;
  }
};